import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/Layout";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: () => import("@/views/HomeView.vue"),
		meta: {
			title: "Home",
		},
	},
	{
		path: "/systemcheck/:roomid",
		name: "SystemCheck",
		component: () => import("@/views/SystemCheck.vue"),
		meta: {
			title: "SystemCheck",
		},
	},
	{
		path: "/meetingend",
		name: "MeetingEnd",
		component: () => import("@/views/MeetingEnd.vue"),
		meta: {
			title: "MeetingEnd",
		},
	},
	{
		path: "/waitingroom",
		name: "WaitingRoom",
		component: () => import("@/views/WaitingRoom.vue"),
		meta: {
			title: "WaitingRoom",
		},
	},
	{
		path: "/:roomid",
		component: Layout,
		children: [
			{
				path: "/:roomid",
				name: "meetingroom",
				component: () => import("@/views/MeetingRoom.vue"),
				meta: {
					title: "MeetingRoom",
				},
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
